import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './allhomes-listing-photo-map.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Map = _ref => {
  var staticMapUrl = _ref.staticMapUrl;
  return ___EmotionJSX("img", {
    src: staticMapUrl,
    alt: "Map showing location of property",
    css: styles.map
  });
};
Map.propTypes = {
  staticMapUrl: PropTypes.string.isRequired
};
export default Map;